import { InvoicesService } from '@festina/moneyin-general-types/moneyin/services/InvoicesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  InvoicesService.installmentPlansServiceDeleteCancelInstallmentPlan

export const useCancelInstallmentPlan = ({ tenantId }: { tenantId: string }) =>
  useFestinaMutation({
    component: 'moneyIn',
    roles:
      InvoicesService.installmentPlansServiceDeleteCancelInstallmentPlan_roles,
    isScenario: false,
    mutateFunction: async (arg: { installmentPlanInvoiceId: string }) => {
      await method({
        xTenantId: tenantId,
        installmentPlanInvoiceId: arg.installmentPlanInvoiceId,
      })
    },
  })
